import React from "react";
import { useAppContext } from "../../AppProvider";
import { useHandlerContext } from "./providers/Handler";
import { getFieldError } from "../../utilities/utilities";
import { ParcelTemplate } from "../../Models/ParcelTemplate";
import SyncSelect from "../../Components/Selects/SyncSelect/SyncSelect";
import { useIndexParcelTemplatesContext } from "./providers/Index";
import InputBoxIcon from "../../Components/Inputs/InputIcon/InputIcon";
import {
  faCube,
  faLoader,
  faRuler,
  faRulerHorizontal,
  faRulerVertical,
  faWeightHanging,
} from "../../utilities/fontawesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTypes } from "../../utilities/types";
import ButtonConfirm from "../../Components/Buttons/Confirm";
import ButtonUtility from "../../Components/Buttons/Utility";

const Handler = () => {
  const { dictionary } = useAppContext();
  const { data, error, loader, callback, edit, onSubmit } = useHandlerContext();
  const indexParcelTemplatesContext = useIndexParcelTemplatesContext();
  const modalConfig = indexParcelTemplatesContext?.modalConfig;
  const { parcels } = useTypes();

  const handleChange = (
    name: string,
    value: string | boolean | number | object | null,
    key: string
  ) => {
    edit(
      { ...data, [name]: value } as ParcelTemplate,
      key as keyof ParcelTemplate,
      false
    );
  };

  const parcelType = parcels.find((x) => x.value === data.parcelTypeCode);

  return (
    <React.Fragment>
      {loader ? (
        <div className="text-center mt-2">
          <FontAwesomeIcon icon={faLoader} spin size="2x" />
        </div>
      ) : (
        <React.Fragment>
          <h3 className="text-center">{modalConfig?.title}</h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              rowGap: "0.5rem",
              columnGap: "1.5rem",
            }}
          >
            <div className="d-flex w-100">
              <div className="w-50 me-2">
                <label className="label-2">{dictionary.words.typology}</label>
                <SyncSelect
                  name="parcelTypeCode"
                  value={parcelType ?? null}
                  onChange={(name, value: any) =>
                    handleChange(name, value.value, "parcelTypeCode")
                  }
                  options={parcels}
                  isClearable={false}
                  error={getFieldError(error, "parcelTypeCode")}
                />
              </div>
              <div className="w-50">
                <label className="label-2">{dictionary.registries.name}</label>
                <InputBoxIcon
                  name="name"
                  value={data?.name}
                  type="text"
                  onChange={({ target }) =>
                    handleChange(target.name, target.value, "name")
                  }
                  placeholder="Template collo"
                  error={getFieldError(error, "name")}
                />
              </div>
            </div>

            <div className="d-flex w-100">
              <div className="me-2 w-50">
                <label className="label-2">
                  {dictionary.dimensions.width + " (cm)"}
                </label>
                <InputBoxIcon
                  name="width"
                  value={data?.width}
                  type="positive-number"
                  onChange={({ target }) =>
                    handleChange(target.name, target.value, "width")
                  }
                  placeholder="10.00"
                  error={getFieldError(error, "width")}
                  icon={faRulerHorizontal}
                />
              </div>
              <div className="me-2 w-50">
                <label className="label-2">
                  {dictionary.dimensions.length + " (cm)"}
                </label>
                <InputBoxIcon
                  name="length"
                  value={data?.length}
                  type="positive-number"
                  onChange={({ target }) =>
                    handleChange(target.name, target.value, "length")
                  }
                  placeholder="10.00"
                  error={getFieldError(error, "length")}
                  icon={faRuler}
                />
              </div>
              <div className="w-50">
                <label className="label-2">
                  {dictionary.dimensions.height + " (cm)"}
                </label>
                <InputBoxIcon
                  name="height"
                  value={data?.height}
                  type="positive-number"
                  onChange={({ target }) =>
                    handleChange(target.name, target.value, "height")
                  }
                  placeholder="10.00"
                  error={getFieldError(error, "height")}
                  icon={faRulerVertical}
                />
              </div>
            </div>

            <div className="d-flex w-100">
              <div className="w-50 me-2">
                <label className="label-2">
                  {dictionary.dimensions.weight + " (kg)"}
                </label>
                <InputBoxIcon
                  name="weight"
                  value={data?.weight}
                  type="positive-number"
                  onChange={({ target }) =>
                    handleChange(target.name, target.value, "weight")
                  }
                  placeholder="1.00"
                  error={getFieldError(error, "weight")}
                  icon={faWeightHanging}
                />
              </div>
              <div className="w-50">
                <label className="label-2">
                  {dictionary.dimensions.volume + " (m3)"}
                </label>
                <InputBoxIcon
                  name="volume"
                  value={data?.volume}
                  type="positive-number"
                  precision={6}
                  error={getFieldError(error, "volume")}
                  icon={faCube}
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <div className="d-flex mt-3">
            <ButtonUtility
              className="w-50 me-2"
              onClick={() => callback?.()}
              disabled={loader}
            >
              {dictionary.actions.cancel}
            </ButtonUtility>
            <ButtonConfirm
              className="w-50"
              onClick={() => onSubmit(data?.id)}
              disabled={loader}
              loading={loader}
            >
              {dictionary.actions.save}
            </ButtonConfirm>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Handler;
